export const CALENDAR_TASKS_FETCH_REQUESTED = 'CALENDAR_TASKS_FETCH_REQUESTED'
export const CALENDAR_TASKS_FETCH_SUCCESS = 'CALENDAR_TASKS_FETCH_SUCCESS'
export const USERS_FETCH_REQUESTED = 'USERS_FETCH_REQUESTED'
export const CALENDAR_TASKS_BY_USER_FETCH_REQUESTED = 'CALENDAR_TASKS_BY_USER_FETCH_REQUESTED'
export const CALENDAR_TASKS_BY_USER_FETCH_SUCCESS = 'CALENDAR_TASKS_BY_USER_FETCH_SUCCESS'
export const UPDATE_DEAL_TASK_REQUESTED = 'UPDATE_DEAL_TASK_REQUESTED'
export const DELETE_DEAL_TASK_REQUESTED = 'DELETE_DEAL_TASK_REQUESTED'
export const DEAL_TASK_MARK_COMPLETED_REQUESTED = 'DEAL_TASK_MARK_COMPLETED_REQUESTED'
export const DEAL_TASK_MARK_NOT_COMPLETED_REQUESTED = 'DEAL_TASK_MARK_NOT_COMPLETED_REQUESTED'
export const UPDATE_DEAL_TASK_SUCCESS = 'UPDATE_DEAL_TASK_SUCCESS'
export const DELETE_DEAL_TASK_SUCCESS = 'DELETE_DEAL_TASK_SUCCESS'
export const CALENDAR_EVENT_SAVE_REQUESTED = 'CALENDAR_EVENT_SAVE_REQUESTED'
export const CALENDAR_EVENT_SAVE_SUCCESS = 'CALENDAR_EVENT_SAVE_SUCCESS'
export const CALENDAR_EVENTS_FETCH_REQUESTED = 'CALENDAR_EVENTS_FETCH_REQUESTED'
export const CALENDAR_EVENTS_FETCH_SUCCESS = 'CALENDAR_EVENTS_FETCH_SUCCESS'
export const CALENDAR_EVENT_UPDATE_REQUESTED = 'CALENDAR_EVENT_UPDATE_REQUESTED'
export const CALENDAR_EVENT_UPDATE_SUCCESS = 'CALENDAR_EVENT_UPDATE_SUCCESS'
export const CALENDAR_EVENTS_BY_USER_FETCH_REQUESTED = 'CALENDAR_EVENTS_BY_USER_FETCH_REQUESTED'
export const CALENDAR_EVENTS_BY_USER_FETCH_SUCCESS = 'CALENDAR_EVENTS_BY_USER_FETCH_SUCCESS'
export const CALENDAR_EVENT_DELETE_REQUESTED = 'CALENDAR_EVENT_DELETE_REQUESTED'
export const CALENDAR_EVENT_DELETE_SUCCESS = 'CALENDAR_EVENT_DELETE_SUCCESS'
export const CALENDAR_FOLLOWUPS_BY_USER_FETCH_REQUESTED =
  'CALENDAR_FOLLOWUPS_BY_USER_FETCH_REQUESTED'
export const CALENDAR_FOLLOWUPS_BY_USER_FETCH_SUCCESS = 'CALENDAR_FOLLOWUPS_BY_USER_FETCH_SUCCESS'
export const CALENDAR_BIDS_BY_USER_FETCH_REQUESTED = 'CALENDAR_BIDS_BY_USER_FETCH_REQUESTED'
export const CALENDAR_BIDS_BY_USER_FETCH_SUCCESS = 'CALENDAR_BIDS_BY_USER_FETCH_SUCCESS'
export const CALENDAR_LEADS_BY_USER_FETCH_REQUESTED = 'CALENDAR_LEADS_BY_USER_FETCH_REQUESTED'
export const CALENDAR_LEADS_BY_USER_FETCH_SUCCESS = 'CALENDAR_LEADS_BY_USER_FETCH_SUCCESS'
export const CALENDAR_BIDS_FETCH_REQUESTED = 'CALENDAR_BIDS_FETCH_REQUESTED'
export const CALENDAR_BIDS_FETCH_SUCCESS = 'CALENDAR_BIDS_FETCH_SUCCESS'
export const CALENDAR_LEADS_FETCH_REQUESTED = 'CALENDAR_LEADS_FETCH_REQUESTED'
export const CALENDAR_LEADS_FETCH_SUCCESS = 'CALENDAR_LEADS_FETCH_SUCCESS'
export const CALENDAR_FOLLOWUPS_FETCH_REQUESTED = 'CALENDAR_FOLLOWUPS_FETCH_REQUESTED'
export const CALENDAR_FOLLOWUPS_FETCH_SUCCESS = 'CALENDAR_FOLLOWUPS_FETCH_SUCCESS'
export const DEAL_DATE_UPDATE_REQUESTED = 'DEAL_DATE_UPDATE_REQUESTED'
export const CALENDAR_DEAL_DATE_UPDATE = 'CALENDAR_DEAL_DATE_UPDATE'
export const DEAL_TASK_MARK_COMPLETED_SUCCESS = 'DEAL_TASK_MARK_COMPLETED_SUCCESS'
